import React, { Component } from "react";
import _ from "lodash";
import PaginationAnchor from "../../static/PaginationAnchor";
import PropTypes from "prop-types";
import {withTranslation} from "react-i18next";
class BrowseTopDrugs extends Component {
  getTopDrugs(language) {
    return this.props.drugs.map((item, id) => (
      <li key={id}>
        <a
          href={`${_.withLocale(language, "/prescription")}/${item.seoName}`}
          title={item.name}
        >
          {item.name}
        </a>
      </li>
    ));
  }

  getAnchorLinks(language) {
    return PaginationAnchor.anchors.map((item, id) => (
      <li key={id}>
        <a
          href={`${_.withLocale(language, "/browse-prescriptions")}/${item.anchor}`}
          className={item.anchor === this.props.term ? "active" : ""}
        >
          {item.anchor}
        </a>
      </li>
    ));
  }

  render() {
    const {t,i18n,heading}=this.props;
    return (
      <div className="browse-top-drugs-wrapper">
        <section className="browse-top-drugs">
          <article>
            <h2 className="browse-top-drugs-heading">
              {heading}
            </h2>
            <ul>{this.getTopDrugs(i18n.language)}</ul>
          </article>
        </section>
        {/*<section className="pagination-anchor">
          <ul>{this.getAnchorLinks(i18n.language)}</ul>
        </section>*/}
      </div>
    );
  }
}

BrowseTopDrugs.propTypes = {
  drugs: PropTypes.array,
  term: PropTypes.string
};

BrowseTopDrugs.defaultProps = {
  drugs: [],
  term: ""
};

export default withTranslation()(BrowseTopDrugs);
